import apiRequest from "../utils/ApiRequest/apiRequest";
import type { ApiResponseObjectT } from "./models";

const GetAllEmbedDynamicFormsNamesByUserIdApiRequest = async (): Promise<
  ApiResponseObjectT<any>
> => {
  const response = await apiRequest(
    "EmbedDynamics",
    "GetAllEmbedDynamicFormsNamesByUserId"
  );

  return response;
};

const GetSitemapJumboformsRequest = async (): Promise<
  ApiResponseObjectT<any>
> => {
  const response = await apiRequest("EmbedDynamics", "GetSitemapJumboforms");

  return response;
};

export {
  GetAllEmbedDynamicFormsNamesByUserIdApiRequest,
  GetSitemapJumboformsRequest,
};
